import React from "react";
import styled from "styled-components";
import { observer } from "mobx-react";

import store, { toggleVisibility, block } from "../canvas/store";
import user, { changeScene } from "../user/index";

import * as Colors from "../reusable/colors";
import { HCenter, VCenter, Divider } from "../reusable/layout";
import { Box, ModalTitle } from "../reusable/components";

const Container = styled.div`
  display: flex;
  width: 100%;
  height: 90%;
  flex-direction: column;
  position: relative;
`;

const Toggle = styled.div`
  height: 70px;
  padding: 10px;
  border: 1px solid ${Colors.primary};
  margin: 10px;
  ${HCenter};
  ${VCenter};
  box-shadow: ${p => p.active && "3px 3px 3px " + Colors.shadow};
  background-color: ${p => p.active && Colors.primary};
  cursor: pointer;
`;

const Label = styled.div`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

const Boxes = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  flex-wrap: wrap;
  background-color: ${Colors.secondary};
`;

export default observer(props => {
  return (
    <Container>
      <Box>
        <ModalTitle>Scenes</ModalTitle>
        <Boxes>
          {user.listScenes.map(s => (
            <Toggle
              key={s.id}
              onClick={() => changeScene(s.id)}
              active={s.id === user.currentScene}>
              {s.label}
            </Toggle>
          ))}
        </Boxes>
      </Box>
      <Divider h="30px" />
      <Box>
        <ModalTitle>Elements</ModalTitle>
        <Boxes>
          {[...store.blocks.get("canvas").children].map(bId => (
            <Toggle key={bId} active={!block(bId).hidden} onClick={() => toggleVisibility(bId)}>
              <Label>{block(bId).label}</Label>
            </Toggle>
          ))}
        </Boxes>
      </Box>
    </Container>
  );
});



// WEBPACK FOOTER //
// ./src/studio/index.js